import "whatwg-fetch";

import { Fetch } from "./Fetch";

export const browserFetchWithOptionalPolyfill: Fetch =
    typeof window === "undefined" || !window?.fetch ? fetch : window.fetch.bind(window);
